import { __assign, __extends } from "tslib";
import memoizeOne from "memoize-one";
import React from "react";
import { warn } from "../utils";
import { TargemProvider, } from "./TargemProvider";
var TargemStatefulBase = /** @class */ (function (_super) {
    __extends(TargemStatefulBase, _super);
    function TargemStatefulBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getValue = memoizeOne(function (propsTranslations, propsLocale, propsDirection) {
            var value = _this.getNewValue(propsTranslations, propsLocale, propsDirection);
            value.changeLocale = _this.props.changeLocale;
            return value;
        });
        return _this;
    }
    return TargemStatefulBase;
}(TargemProvider));
export { TargemStatefulBase };
var TargemStatefulProvider = /** @class */ (function (_super) {
    __extends(TargemStatefulProvider, _super);
    function TargemStatefulProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.changeLocale = function (locale) {
            if (!locale) {
                warn("Empty locale was passed to 'changeLocale()'!");
            }
            if (locale === _this.state.locale) {
                return;
            }
            _this.setState({ locale: locale });
        };
        return _this;
    }
    TargemStatefulProvider.prototype.render = function () {
        return (React.createElement(TargemStatefulBase, __assign({ changeLocale: this.changeLocale, locale: this.state.locale }, this.props)));
    };
    return TargemStatefulProvider;
}(React.PureComponent));
export { TargemStatefulProvider };
//# sourceMappingURL=TargemStatefulProvider.js.map